import React from 'react';
import { useAppSelector } from '../../../state/hooks';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';
import ButtonWithArrowOnHover from '../../buttonWithArrowOnHover/ButtonWithArrowOnHover';
import { BrandAwarenessUsageExperienceStyles } from './styles';

export const BrandAwarenessUsageExperience = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);
  return (
    <BrandAwarenessUsageExperienceStyles>
      <div className="container">
        <h5>
          {getTranslationsByLangOrEng(interfaceLanguage, 'usage_attitude_9')}
        </h5>
        <div className="content">
          <h2>
            {getTranslationsByLangOrEng(interfaceLanguage, 'usage_attitude_10')}
          </h2>
          <div className="btn-container">
            <ButtonWithArrowOnHover
              onClick={() => {
                const elem = document.getElementById('form');
                elem!.scrollIntoView({ block: 'start', behavior: 'smooth' });
              }}
              arrowColor="#fff"
              textColor="#000"
              borderColor="#000"
              borderOnHover="#000"
              background="linear-gradient(135.55deg, #BBBAFF 0%, #8E50CC 100.95%)"
              hoverBackground="#000"
              hoverTextColor="#fff"
              text={getTranslationsByLangOrEng(
                interfaceLanguage,
                'usage_attitude_11',
              )}
            />
          </div>
        </div>
      </div>
    </BrandAwarenessUsageExperienceStyles>
  );
};
